import { Container, Reveal, RevealGroup } from '@/components/common'
import { becFramework } from '@/constants/bec-framework'

export const BecFramework = () => {
  return (
    <section className="bg-ibon-teal py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
              The future is <span className="text-white/30">BEC.</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-white/60">
              Connecting Business (Entrepreneurship), Education &amp; Leadership, and Culture: three
              interconnected pillars working together to unlock the potential of young people across
              Africa and the Caribbean.
            </p>
          </Reveal>
        </div>

        <RevealGroup className="mt-16 grid gap-8 lg:grid-cols-3">
          {becFramework.map(({ key, letter, title, description, Icon }) => (
            <article
              key={key}
              className="group relative flex flex-col overflow-hidden border border-white/10 bg-white/5 p-8 transition-colors hover:bg-ibon-dark lg:p-10"
            >
              <span className="pointer-events-none absolute -right-4 -top-8 text-[9rem] font-bold leading-none text-white/5 transition-colors duration-300 group-hover:text-white/10">
                {letter}
              </span>
              <Icon className="relative text-4xl text-ibon-sky" />
              <h3 className="relative mt-8 text-3xl font-bold tracking-tight text-white transition-colors duration-300 group-hover:text-white">
                {title}
              </h3>
              <p className="relative mt-5 text-base leading-relaxed text-white/60 transition-colors duration-300 group-hover:text-white/70">
                {description}
              </p>
            </article>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
